// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"016e1038ad2185dae0c1","883":"13f2b56edf71a998603a"}[chunkId] + ".js";
};